import {EyeIcon} from '~library/svg/EyeIcon';
import {useSheetOptions} from '~/SignUpSheets/components/Header/components/SheetOptions/context/SheetOptionsContext';
import {SheetOption} from '~/SignUpSheets/components/Header/components/SheetOptions/components/SheetOption/SheetOption';

export const ViewSheet = () => {
  const {closeOptions} = useSheetOptions();

  return <SheetOption title="View sheet" icon={<EyeIcon ratio={0.5} />} onClick={closeOptions} />;
};
